import React from "react"
import ReactDOM from 'react-dom';
import SlidingGallery from "../../SlidingGallery/SlidingGallery"

ReactDOM.render(
   <SlidingGallery apiUrl="/products/interactive-flat-panel-displays/Tutorials" />,
    document.getElementById("tutorial-app")
);